/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import axios from "axios";
import qs from "qs";
import { baseApi, baseApiV2, cardAddApi } from "../../constants/Presets";

/* istanbul ignore next */
export const RequestLogin = (payload) =>
  axios.post(`${baseApiV2}auth/login`, qs.stringify(payload));
export function ForgotPassword(email) {
  const postData = {
    email,
  };
  return axios.post(
    `${baseApiV2}users/resetPasswordLinkSend`,
    qs.stringify(postData),
  );
}
/* istanbul ignore next */
export function ChangePassword(payload) {
  return axios.post(
    `${baseApiV2}users/resetPassAfterLogin`,
    qs.stringify({
      password: payload.pass,
      op_type: payload.flag,
    }),
  );
}
/* istanbul ignore next */
export function ResetPassword(payload) {
  return axios.post(
    `${baseApiV2}users/resetPassword`,
    qs.stringify({
      password: payload.password,
      checksum: payload.checksum,
      reCaptchaToken: payload.reCaptchaToken,
    }),
  );
}
/* istanbul ignore next */
export function SignupUser(payload) {
  return axios({
    method: "post",
    url: `${baseApiV2}user/signup`,
    data: {
      email: payload.emailId,
      mediaTailor: payload.isMediaTailor,
    },
  });
}
/* istanbul ignore next */
export function CompleteSignup(payload) {
  return axios({
    method: "post",
    url: `${baseApiV2}user/registration`,
    params: {
      companyName: payload.company,
      user: payload.name,
      checksum: payload.companyChecksum,
      password: payload.password,
      companyCheck:
        payload.companyCheck === true || payload.companyCheck === false
          ? payload.companyCheck
          : true,
      isV4: payload.isV4,
      mediaTailor: payload.isMediaTailor,
    },
  });
}
//
// ─── SAVE CARD DETAILS ──────────────────────────────────────────────────────────
//
/* istanbul ignore next */
export function CardAdd(payload) {
  return axios({
    method: "post",
    url: cardAddApi,
    data: payload,
  });
}
//
// ─── FETCH CARD DETAILS ─────────────────────────────────────────────────────────
//
/* istanbul ignore next */
export function FetchCardDetails(payload) {
  const customerCode = payload.companyId || "";
  const url = `${baseApiV2}stripe/getCards?companyId=${customerCode}`;
  return axios.get(url);
}
//
// ─── FETCH USER DETAILS ─────────────────────────────────────────────────────────
// /
/* istanbul ignore next */
export function FetchUserDetails(id) {
  const payload = id !== undefined ? `?companyId=${id}` : "";
  const url = `${baseApiV2}company/companyDetails${payload}`;
  return new Promise((resolve, rejct) => {
    setTimeout(() => {
      resolve(axios.get(url));
    });
  });
}
/* istanbul ignore next */
export function RequestRefreshToken() {
  return axios.post(`${baseApiV2}auth/refresh-jwt`);
}
/* istanbul ignore next */
export function RequestLogout() {
  return axios.get(`${baseApiV2}auth/logout`);
}

export function SocialSignup(payload) {
  const url = `${baseApi}api/oauth/${payload.provider}`;
  const config = {
    method: "post",
    url,
    data: { authorizationCode: payload.code },
  };
  return axios(config);
}

export function RefreshHelpSite() {
  return axios({
    method: "post",
    url: `${baseApi}helpsite/sync`,
  });
}

export function CheckEligibilitySSO(payload) {
  return axios({
    method: "post",
    url: `${baseApiV2}auth/check_eligibility`,
    data: payload,
  });
}

export function SSOCallback(payload) {
  const url = `${baseApiV2}auth/sso/callback`;
  const config = {
    method: "get",
    url,
    params: payload,
  };
  return axios(config);
}
